import freeGlobal from "./component-library239.mjs";
var freeSelf = typeof self == "object" && self && self.Object === Object && self;
var root = freeGlobal || freeSelf || Function("return this")();
const root$1 = root;
export {
  root$1 as default
};
